import { render, staticRenderFns } from "./GovernmentAdvisories.vue?vue&type=template&id=24daf89c&scoped=true"
import script from "./GovernmentAdvisories.vue?vue&type=script&lang=js"
export * from "./GovernmentAdvisories.vue?vue&type=script&lang=js"
import style0 from "./GovernmentAdvisories.vue?vue&type=style&index=0&id=24daf89c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24daf89c",
  null
  
)

export default component.exports